
import React from 'react';
import type { CompanyInfo } from '../types';
import { CompanyCard } from './CompanyCard';

interface ResultsDisplayProps {
  results: CompanyInfo[];
}

export const ResultsDisplay: React.FC<ResultsDisplayProps> = ({ results }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {results.map((info, index) => (
        <CompanyCard key={info.unifiedBusinessNumber || index} info={info} />
      ))}
    </div>
  );
};
